/** Public AI hub and use-case doc paths (PBI #1318). */
export const AI_PUBLIC_ROUTES = {
  hub: '/ai',
  useCaseCatalog: '/ai/use-cases/catalog-and-planning',
  useCaseScheduling: '/ai/use-cases/schedule-with-assistant',
} as const;
